import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";

const AdAccounts = () => {
  const history = useNavigate();

  const [adAccountsData, setAdAccountsData] = useState<any[]>([]);

  const fbbPageInfo: any = localStorage.getItem("fbbPageDetail");
  const recFbPageInfp = JSON.parse(fbbPageInfo)?.facebook;

  const systemUserId = recFbPageInfp?.systemUserId;
  const clientBusinessId = recFbPageInfp?.clientBusinessId;
  const count = adAccountsData.length;

  useEffect(() => {
    const pageDataReq = `systemUserId=${systemUserId}&clientBusinessId=${clientBusinessId}`;

    NetworkManager.sendJsonRequest(
      "broadcastMessageTemplates/getAdAccountsOfBusiness",
      "",
      pageDataReq,
      "GET",
      true,
      onSuccessCallAdAccounts,
      onErrorCallAdAccounts
    );
  }, [clientBusinessId, systemUserId]);

  const onSuccessCallAdAccounts = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData?.adAccountsList) {
      setAdAccountsData(respData.adAccountsList);
    }
  };
  const onErrorCallAdAccounts = () => {};

  const onConnectToCampaigns = (item: any) => {
    localStorage.setItem("fbbAdAccountDetail", JSON.stringify(item));
    history("/dashboard/dmcampaigns");
  };

  return (
    <>
      <div className="account-pages container-login100 mt-0.5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 text-center mb-2">
              <img src="../assets/images/Logo.png" alt="" />
            </div>
          </div>
          <div className="row justify-content-center mb-4 manage">
            <div className="col-md-12 col-lg-8 col-xl-6">
              <div className="text-center">
                <h3 className="fbtext">
                  {adAccountsData && count ? (
                    <div>We found {count ? count : 0} Ad Accounts.</div>
                  ) : (
                    <div>Fetching Ad Accounts.</div>
                  )}
                </h3>
              </div>
              <div
                className="custom-scrollbar-css p-2"
                style={{ maxHeight: "65vh", overflowY: "auto" }}>
                {adAccountsData && count > 0
                  ? adAccountsData.map((item: any, index: any) => {
                      return (
                        <div className="card" key={index}>
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="widgets_div d-flex align-items-center">
                                <div
                                  className="av-div"
                                  style={{
                                    textAlign: "start",
                                    fontSize: "16px",
                                  }}>
                                  {item?.adAccountName}
                                  <br />
                                  <span
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}>
                                    {item?.adAccountId}
                                  </span>
                                </div>
                              </div>
                              <div className="text-right">
                                <button
                                  type="button"
                                  className="btn rounded-pill btn-small btn-sm btn-primary"
                                  style={{ float: "right" }}
                                  onClick={() => onConnectToCampaigns(item)}>
                                  Campaigns
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdAccounts;
